import "@ids/web-component-error-message";

import type { HTMLAttributes } from "react";

type IdsErrorMessageProps = HTMLAttributes<HTMLElement>;

declare module "react" {
  namespace JSX {
    interface IntrinsicElements {
      "ids-error-message": IdsErrorMessageProps;
    }
  }
}

const IdsErrorMessage = (props: IdsErrorMessageProps) => {
  return <ids-error-message {...props} />;
};

export const ErrorMessage = (props: IdsErrorMessageProps) => (
  <IdsErrorMessage {...props} />
);
